import { Divider, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { FC } from "react";
import { Controller, Control } from "react-hook-form";
import { InferenceForm } from "views/inference/types";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  textarea: {
    height: "150px",
    color: '#000000',
    padding: 5,
    border: "1.2px solid #c6c6c6",
    borderRadius: '5px',
    minWidth: "100%",
    maxWidth: "100%",
    fontFamily: "inherit",
    fontSize: '0.875rem',
  },
  divider: {
    backgroundColor: "lightGray", marginBottom: "5px"
  }
}));

type Props = {
  control: Control<InferenceForm, any>,
}

export const Prompt: FC<Props> = ({ control }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Typography style={{ color: "#000000" }}>{t('inference:systemMessageLabel')}</Typography>
      <Divider className={classes.divider} />
      <Controller
        control={control}
        name="systemMessage"
        render={({ field }) => (
          <textarea
            className={classes.textarea}
            placeholder=""
            style={{ marginTop: "5px", height: "auto" }}
            value={field.value}
            onChange={(e) => field.onChange(e.target.value)}
          />
        )}
      />

      <Typography style={{ color: "#000000" }}>{t('inference:userMessageLabel')}</Typography>
      <Divider className={classes.divider} />
      <Controller
        control={control}
        name="userMessage"
        render={({ field }) => (
          <textarea
            className={classes.textarea}
            placeholder=""
            style={{ marginTop: "5px", minHeight: "450px" }}
            value={field.value}
            onChange={(e) => field.onChange(e.target.value)}
          />
        )}
      />
    </>
  );
};
